export default "__VITE_ASSET__CBzipdCz__"